import {
  GET_BOOKMARKS,
  GET_BOOKMARKS_SUCCESS,
  GET_BOOKMARKS_ERROR,
  DELETE_BOOKMARK,
  DELETE_BOOKMARK_SUCCESS,
  DELETE_BOOKMARK_ERROR,
} from "../../constants/action-types";

export const bookmarkInitialState = {
  isFetching: false,
  isError: false,
  bookmarks: [],
  isDeleting: false,
};

export const reducer = (state = bookmarkInitialState, { type, payload }) => {
  switch (type) {
    case GET_BOOKMARKS: {
      return {
        ...state,
        isFetching: true,
        isError: false,
      };
    }
    case GET_BOOKMARKS_SUCCESS: {
      return {
        ...state,
        bookmarks: payload,
        isFetching: false,
        isError: false,
      };
    }
    case GET_BOOKMARKS_ERROR: {
      return {
        ...state,
        isFetching: false,
        isError: true,
      };
    }
    case DELETE_BOOKMARK: {
      return {
        ...state,
        isDeleting: true,
      };
    }
    case DELETE_BOOKMARK_SUCCESS: {
      return {
        ...state,
        bookmarks: [
          ...state.bookmarks.slice(0, payload),
          ...state.bookmarks.slice(payload + 1),
        ],
        isDeleting: false,
      };
    }
    case DELETE_BOOKMARK_ERROR: {
      return {
        ...state,
        isDeleting: false,
      };
    }
    default:
      return state;
  }
};
